module.exports = __webpack_public_path__ + "img/speaking_Scene2.57937d41.gif";